module.exports = __webpack_public_path__ + "media/images/about-1-dcc53ca3341f01ca82bfa1b41a0a4180.png";